/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PickupType } from './PickupType';
import {
    PickupTypeFromJSON,
    PickupTypeFromJSONTyped,
    PickupTypeToJSON,
    PickupTypeToJSONTyped,
} from './PickupType';

/**
 * Rental car pickup location details — how the renter gets from the airport to the counter
 * @export
 * @interface PickupLogistics
 */
export interface PickupLogistics {
    /**
     * 
     * @type {PickupType}
     * @memberof PickupLogistics
     */
    pickupType?: PickupType;
    /**
     * Counter location description from the vendor (e.g., "Terminal 1, Level 1")
     * @type {string}
     * @memberof PickupLogistics
     */
    counterLocation?: string;
    /**
     * Shuttle service details if applicable (e.g., "Complimentary shuttle every 10 minutes")
     * @type {string}
     * @memberof PickupLogistics
     */
    shuttleInfo?: string;
    /**
     * Street address of the rental facility
     * @type {string}
     * @memberof PickupLogistics
     */
    address?: string;
    /**
     * Phone number for the rental location
     * @type {string}
     * @memberof PickupLogistics
     */
    phone?: string;
}



/**
 * Check if a given object implements the PickupLogistics interface.
 */
export function instanceOfPickupLogistics(value: object): value is PickupLogistics {
    return true;
}

export function PickupLogisticsFromJSON(json: any): PickupLogistics {
    return PickupLogisticsFromJSONTyped(json, false);
}

export function PickupLogisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PickupLogistics {
    if (json == null) {
        return json;
    }
    return {
        
        'pickupType': json['pickup_type'] == null ? undefined : PickupTypeFromJSON(json['pickup_type']),
        'counterLocation': json['counter_location'] == null ? undefined : json['counter_location'],
        'shuttleInfo': json['shuttle_info'] == null ? undefined : json['shuttle_info'],
        'address': json['address'] == null ? undefined : json['address'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function PickupLogisticsToJSON(json: any): PickupLogistics {
    return PickupLogisticsToJSONTyped(json, false);
}

export function PickupLogisticsToJSONTyped(value?: PickupLogistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pickup_type': PickupTypeToJSON(value['pickupType']),
        'counter_location': value['counterLocation'],
        'shuttle_info': value['shuttleInfo'],
        'address': value['address'],
        'phone': value['phone'],
    };
}

